var _excluded = ["item", "isShown"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Settings panel for the map
import { Switch, Icon } from "@blueprintjs/core";
import hyper from "@macrostrat/hyper";
import { Tag, Button, Collapse, Callout } from "@blueprintjs/core";
//import { LinkButton } from "@macrostrat/ui-components";
//import { GlobeSettings } from "@macrostrat/cesium-viewer/settings";
import { useAppState, useAppActions } from "~/map-interface/app-state";
import { MapLayer } from "~/map-interface/app-state"; //import { DisplayQuality } from "@macrostrat/cesium-viewer";

import styles from "./settings-panel.module.styl";
import { DarkModeButton, useDarkMode, darkModeUpdater } from "@macrostrat/ui-components";
var h = hyper.styled(styles);
/*
function MapTypeButton(props) {
  const { pathname, hash } = useLocation();
  const globeActive = pathname?.startsWith("/globe");
  if (globeActive) {
    return h(LinkButton, { to: { pathname: "/map", hash } }, "Switch to map");
  }
  return h(LinkButton, { to: { pathname: "/globe", hash } }, "Switch to globe");
}
*/

var ExperimentsPanel = function ExperimentsPanel(props) {
  var dispatch = useAppActions(); //const { pathname } = useLocation();
  //const globeActive = pathname?.startsWith("/globe");

  return h("div.settings.experiments.bp4-text.text-panel", [h("h2", "Experimental settings"), h(Switch, {
    checked: useAppState(function (s) {
      return s.core.mapLayers.has(MapLayer.SOURCES);
    }),
    onChange: function onChange() {
      dispatch({
        type: "toggle-map-layer",
        layer: MapLayer.SOURCES
      });
    }
  }, "Show sources") //h(MapTypeButton),
  //h.if(globeActive)(GlobeSettings),
  ]);
};

var SettingsPanel = function SettingsPanel(props) {
  //const { pathname } = useLocation();
  //const globeActive = pathname?.startsWith("/globe");
  var runAction = useAppActions();
  var showExperiments = useAppState(function (s) {
    return s.core.showExperimentsPanel;
  });
  return h("div.settings", [h("p.info", "Display options for Macrostrat's map."), //h(ButtonGroup, { vertical: true, alignText: Alignment.LEFT }, [
  h(LabelsButton), h(ThemeButton), //h(HighResolutionTerrainSwitch),
  h("div.callout-panel", {
    className: showExperiments ? "expanded" : null
  }, [h("div.callout-header", [h(Button, {
    minimal: true,
    icon: "clean",
    active: showExperiments,
    intent: "warning",
    onClick: function onClick() {
      runAction({
        type: "toggle-experiments-panel"
      });
    }
  }, "Experiments")]), h(Collapse, {
    isOpen: showExperiments,
    className: "callout-content"
  }, h(Callout, {
    intent: "warning",
    icon: null
  }, [h(LineSymbolsControl), h(SourcesButton)]))])]);
};

function LineSymbolsControl() {
  var runAction = useAppActions();
  return h("div.control-wrapper", [h(Switch, {
    checked: useAppState(function (s) {
      return s.core.mapLayers.has(MapLayer.LINE_SYMBOLS);
    }),
    onChange: function onChange() {
      runAction({
        type: "toggle-map-layer",
        layer: MapLayer.LINE_SYMBOLS
      });
    }
  }, [h("span.control-label", [h("span.control-label-text", "Line symbols"), h(Tag, {
    intent: "danger",
    icon: "issue",
    minimal: true
  }, "Data issues")])]), h("p.admonition", "Geologic structure orientations are often incorrect due to inconsistent source data.")]);
}

function ThemeButton() {
  var darkMode = useDarkMode();
  var update = darkModeUpdater();
  var icon = darkMode.isAutoset ? "tick" : "desktop";
  var autoButton = h(Button, {
    minimal: true,
    active: darkMode.isAutoset,
    rightIcon: h(Icon, {
      icon: icon,
      size: 12
    }),
    intent: darkMode.isAutoset ? "success" : "primary",
    className: "auto-button sub-button",
    small: true,
    onClick: function onClick(evt) {
      if (darkMode.isAutoset) return;
      evt.stopPropagation();
      update(null);
    }
  }, "auto");
  var darkModeText = darkMode.isEnabled ? "Turn on the lights" : "Turn off the lights";
  return h("div.dark-mode-controls", [h(DarkModeButton, {
    minimal: true,
    active: false,
    allowReset: true,
    rightIcon: autoButton
  }, [h("span.text", darkModeText)])]);
}

function LabelsButton() {
  var layer = MapLayer.LABELS;
  var isShown = useAppState(function (state) {
    return state.core.mapLayers.has(layer);
  });
  var runAction = useAppActions();

  var onClick = function onClick() {
    return runAction({
      type: "toggle-map-layer",
      layer: layer
    });
  };

  return h(ShowHideButton, {
    minimal: true,
    icon: "label",
    onClick: onClick,
    isShown: isShown,
    item: "basemap labels"
  });
}

function ShowHideButton(_ref) {
  var item = _ref.item,
      isShown = _ref.isShown,
      rest = _objectWithoutProperties(_ref, _excluded);

  var text = isShown ? "Hide" : "Show";
  text += " ".concat(item);
  return h(Button, _objectSpread({
    active: false
  }, rest), text);
}

function SourcesButton() {
  var dispatch = useAppActions();
  return h(Switch, {
    checked: useAppState(function (s) {
      return s.core.mapLayers.has(MapLayer.SOURCES);
    }),
    onChange: function onChange() {
      dispatch({
        type: "toggle-map-layer",
        layer: MapLayer.SOURCES
      });
    }
  }, "Show sources");
}

function HighResolutionTerrainSwitch() {
  var dispatch = useAppActions();
  return h("div.control-wrapper", null, h(Switch, {
    checked: useAppState(function (s) {
      return s.core.mapSettings.highResolutionTerrain;
    }),
    onChange: function onChange() {
      dispatch({
        type: "toggle-high-resolution-terrain"
      });
    }
  }, "High-resolution terrain"));
}

export { ExperimentsPanel, SettingsPanel, ThemeButton };